module.exports = __webpack_public_path__ + "img/engagement_rings@2x.abe65f2.webp";